import { fetchExternal, getSecureTimeoutMs } from "./httpClient";
import { createIntegrationError, ERROR_TYPES } from "./integrationErrors";
import { REACT_APP_SECURE } from "../../config/env";

export function lookupTransaction(refPayco) {
  if (!refPayco) {
    return Promise.reject(
      createIntegrationError(ERROR_TYPES.CONTRACT_ERROR, {
        endpoint: "checkout-transaction",
      })
    );
  }

  const url = `${REACT_APP_SECURE}/${refPayco}`;
  return fetchExternal(url, {}, getSecureTimeoutMs());
}
